<template>
  <div class="DetailEquity">

    <div class="equity-tab">
      <div class="equity-tab-item"
           :class="[{ 'ON': index == tabIndex },vo.className]"
           v-for="(vo,index) in TUPIAN_DETAIL.EQUITY_LIST"
           :key="vo.label"
           @click="toggleTab(vo,index)"
      >
        {{ vo.label }}
        <div class="bar"></div>
      </div>
    </div>

    <div class="equity-content">

      <div class="equity-item-content ">
        <div class="title">
          {{ TUPIAN_DETAIL.EQUITY_LIST[tabIndex].title }}
        </div>
        <div class="list">
          <div class="list-item"
               v-for="vo in TUPIAN_DETAIL.EQUITY_LIST[tabIndex].list"
               :key="vo.label"
          >
            <i
              :class="[ vo.isCheck ? 'iconfont icon-gou21' : 'iconfont3 icon-cz-close-circle-fill']"
              class=""></i>
            {{ vo.label }}
          </div>
        </div>
      </div>

      <div class="equity-item-content equity-item-content2">
        <div class="title">
          {{ TUPIAN_DETAIL.EQUITY_LIST[tabIndex].title2 }}
          <div class="compare-equity" v-if="tabIndex == 2" @click="showDetailEquityCompare">
            授权范围对比<i class="iconfont icon-a-arrowright" />
          </div>
        </div>
        <div class="list">
          <div class="list-item"
               v-for="vo in TUPIAN_DETAIL.EQUITY_LIST[tabIndex].list2"
               :key="vo.label"
          >
            <i
              v-if="vo.label != '' "
              :class="[ vo.isCheck ? 'iconfont icon-gou21' : 'iconfont3 icon-cz-close-circle-fill']"
              class=""></i>
            {{ vo.label }}
          </div>
        </div>
      </div>
    </div>


    <!-- 企业权益对比弹框 -->
<!--    <DetailEquityCompare ref="DetailEquityCompare"/>-->

  </div>
</template>

<script>
import {TUPIAN_DETAIL} from "@/constant/tupian/TUPIAN_DETAIL";
import DetailEquityCompare from '@/components/tupian/detail/detail-equity/detail-equity-compare'
import {fnBasic} from "@/fn/_fn";

export default {
  name: "DetailEquity",
  components:{
    DetailEquityCompare
  },
  data() {
    return {
      TUPIAN_DETAIL,
      tabIndex: 1
    }
  },
  methods: {
    toggleTab(vo, index) {
      this.tabIndex = index;
    },

    showDetailEquityCompare(){
      fnBasic.navigationTo('/introduce/company')
      // this.$refs.DetailEquityCompare.isShow = true;
    }
  }
}
</script>

<style lang="scss" scoped>
.DetailEquity {
  margin: 32px 0;

  width: 430px;
  background: #FFFFFF;
  box-shadow: 0px 0px 12px 0px rgba(66, 72, 102, 0.08);
  border-radius: 14px;
  overflow: hidden;

  .equity-tab {
    height: 54px;
    line-height: 54px;
    display: flex;
    background: rgba(245, 246, 250, 1);

    .equity-tab-item {
      width: 33.33%;
      height: 100%;
      text-align: center;
      font-size: 15px;
      color: #424866;
      letter-spacing: 1px;
      cursor: pointer;

      .bar {
        width: 60px;
        height: 3px;
        background: #6969FF;
        border-radius: 2px;
        @include Position(1, 4, 50%, 0);
        transform: translateX(-50%);
        display: none;
      }

      &.ON {
        background: #FFFFFF;
        border-radius: 14px 14px 0px 0px;
        position: relative;
        font-size: 15px;
        font-weight: bold;
        color: #6969FF;
        letter-spacing: 1px;

        .bar{
          display: block !important;
        }

        &.person {
          color: #6969FF;
        }

        &.company {
          color: #404670;

          .bar {
            background: #404670;
          }
        }

        &:before {
          content: '';
          display: inline-block;
          @include BgImage(10px, 10px, 'tupian/detail/icon_sj.png');
          @include Position(1, 4, -10px, 0);
        }

        &:after {
          content: '';
          display: inline-block;
          @include BgImage(10px, 10px, 'tupian/detail/icon_sj.png');
          @include Position(1, 3, -10px, 0);
          transform: rotateY(180deg);
        }
      }
    }
  }

  .equity-content {
    padding: 22px 22px 12px 28px;
    box-sizing: border-box;

    .equity-item-content {
      .title {
        font-size: 14px;
        color: #001013;
        line-height: 20px;
        letter-spacing: 1px;
        margin-bottom: 16px;
        position: relative;

        .compare-equity{
          @include Position(1,2,0,50%);
          transform: translateY(-50%);
          font-size: 13px;
          color: rgba(0, 16, 19, 0.5);
          line-height: 18px;
          .icon-a-arrowright{
            font-size: 14px;
          }

          @include ElementHover(rgba(0, 16, 19, 0.6))
        }
      }

      .list {

        .list-item {
          height: 20px;
          display: flex;
          align-items: center;
          font-size: 14px;
          color: rgba(0, 16, 19, 0.65);
          letter-spacing: 1px;
          white-space: nowrap;

          .icon-gou21 {
            color: #35D0BA;
            font-size: 16px;
            margin-right: 10px;
            position: relative;
            top: 1px;
          }

          .icon-cz-close-circle-fill {
            color: #C6C8D3;
            font-size: 16px;
            margin-right: 10px;
            position: relative;
            top: 1px;
          }

        }
      }

      &:first-child {
        margin-bottom: 26px;
      }

      &.equity-item-content2 {

        .list {
          display: flex;
          flex-wrap: wrap;

          .list-item {
            width: 50%;
            margin-bottom: 14px;
          }
        }
      }


    }
  }
}
</style>
